import {ApiPatientResponse} from '../http/api-patient-response';
import {ApiFileResponse} from '../http/api-file-response';
import {MeasureTypeEnum} from '../../../../core/services/state/measure-type.enum';
import {PressureUnitEnum} from '../../../../core/services/state/pressure-unit.enum';
import {GenderEnum} from '../../../../core/services/state/gender.enum';
import {AvailablePatientOptions} from './patient/available-patient-options';
import {Shunt} from './patient/shunt';
import {TimestampedComment} from './timestamped-comment';
import {MeasureResults} from './measure-results';
import {Measurement} from './measurement';
import {InfusionInterval} from './infusion-interval';
import {InfusionParametersResults} from './infusion-parameters-results';
import {BaselineParametersResults} from './baseline-parameters-results';

export class PatientData {

  public id: string = '';
  public patient: ApiPatientResponse | null = null;
  public file: ApiFileResponse | null = null;

  // Case info
  public measureType: MeasureTypeEnum = MeasureTypeEnum.BASELINE;
  public needleGauge: string = '';
  public pressureUnit: PressureUnitEnum = PressureUnitEnum.MM_HG;
  public createdAt: string = new Date().toISOString();

  // Patient info
  public firstName: string = '';
  public lastName: string = '';
  public gender: GenderEnum = GenderEnum.MALE;
  public birthDate: string = new Date().toISOString();
  public age: number = 0;
  public medicalId: string = '';
  public readonly medicalHistory: AvailablePatientOptions = new AvailablePatientOptions([], false);
  public readonly clinicalSigns: AvailablePatientOptions = new AvailablePatientOptions([], false);
  public readonly imaging: AvailablePatientOptions = new AvailablePatientOptions([], false);
  public shunt: Shunt | null = null;
  public comments: string = '';

  // Measurements
  public infusionRate: number | null = null;
  public algoResultsId: string = '';
  public timestampedComments: Array<TimestampedComment> = [];
  public results: MeasureResults = new MeasureResults(null, null);
  public measurements: Array<Measurement> = [];
  public infusionIntervals: Array<InfusionInterval> = [];

  constructor() {
  }

  public get firstMeasurement(): Measurement | null {
    if (this.measurements.length === 0) {
      return null;
    }
    return this.measurements[0];
  }

  public get lastMeasurement(): Measurement | null {
    if (this.measurements.length === 0) {
      return null;
    }
    return this.measurements[this.measurements.length - 1];
  }

  public get basalResults(): BaselineParametersResults | null {
    return this.results.baselineParametersResults;
  }

  public get infusionResults(): InfusionParametersResults | null {
    return this.results.infusionParametersResults;
  }

}
